import { render, staticRenderFns } from "./SelectBusinessHeader.vue?vue&type=template&id=1f2c2154&scoped=true"
import script from "./SelectBusinessHeader.vue?vue&type=script&lang=js"
export * from "./SelectBusinessHeader.vue?vue&type=script&lang=js"
import style0 from "./SelectBusinessHeader.vue?vue&type=style&index=0&id=1f2c2154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c2154",
  null
  
)

export default component.exports